import store, {persistor} from '@store';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {PersistGate} from 'redux-persist/integration/react';
import {DefaultTheme, ThemeProvider} from 'styled-components';
import {ReadableStream} from 'web-streams-polyfill';

import {getTheme} from '@shared/api/api';

import App from './App';
import Config from './config/themeConfig.json';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const themeName = getTheme();
const selectedTheme =
  Config.find((config) => config.themeName === themeName) ||
  Config.find((config) => config.themeName === 'default');

if (!selectedTheme) {
  throw new Error('Default theme configuration is missing.');
}

const {theme} = selectedTheme;

if (typeof window !== 'undefined' && !window.ReadableStream) {
  (window as any).ReadableStream = ReadableStream;
}

function RootApp() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <PersistGate persistor={persistor}>
          <ThemeProvider theme={theme as DefaultTheme}>
            <App />
          </ThemeProvider>
        </PersistGate>
      </BrowserRouter>
    </Provider>
  );
}

root.render(<RootApp />);

reportWebVitals();
